var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isDesigner())?_c('span',[_vm._v("数据列表")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }